import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=6ec6c376"
import script from "./IndexLayout.vue?vue&type=script&lang=js"
export * from "./IndexLayout.vue?vue&type=script&lang=js"
import style0 from "./IndexLayout.vue?vue&type=style&index=0&id=6ec6c376&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports